export const OUTCOMES = [
  ["nuovo", "Nuovi", "text-[#10B981]"], ["gia_esistente", "Già presenti", "text-slate-300"], ["aggiornabile", "Aggiornabili", "text-sky-400"],
  ["duplicato_file", "Duplicati nel file", "text-amber-400"], ["ambiguo", "Ambigui", "text-orange-400"], ["non_valido", "Numeri non validi", "text-red-400"], ["incompleto", "Scartate", "text-red-300"],
];
export const FIELD_LABELS = { name: "Nome", surname: "Cognome", email: "Email", store: "Punto vendita", card_code: "Codice carta", city: "Città", preferred_channel: "Canale preferito", external_customer_id: "ID cliente esterno", tags: "Tag", custom_fields: "Campi personalizzati" };
export const UPDATABLE = ["name", "surname", "email", "store", "card_code", "city", "preferred_channel", "external_customer_id", "tags", "custom_fields"];
export const outcomeLabel = (k) => OUTCOMES.find((o) => o[0] === k)?.[1] || (k === "aggiornato" ? "Aggiornato" : k);
export const outcomeClass = (k) => OUTCOMES.find((o) => o[0] === k)?.[2] || "text-sky-400";
export const box = "bg-[#0A0E17] border border-[#1F2937] rounded-xl";
export const inputCls = "bg-[#0A0E17] border-[#1F2937] h-9 text-slate-100";
export const fmtDate = (s) => (s ? new Date(s).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "");

export function downloadBlob(data, name) {
  const url = URL.createObjectURL(data instanceof Blob ? data : new Blob([data]));
  const a = document.createElement("a"); a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
}
export function filenameFrom(headers, fallback) {
  const m = /filename="?([^";]+)"?/.exec(headers?.["content-disposition"] || "");
  return m ? m[1] : fallback;
}
